export const QUERY_FILTER_NAMESPACE = 'amplifyQueryFilter';
